import styled from 'styled-components/macro';
import { MiniButton } from '@yme/atoms/mini-button';
import { boxStyled } from '@yme/pages/components/ProductsGrid/components/ComparisonFilter/components/FilterResults/styled';
export const FiltersButtonStyled = styled(MiniButton) `
  ${boxStyled};

  padding: 10px 16px 10px 10px;

  width: 100%;

  white-space: nowrap;
`;
